@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t">
  <div class="widget-container">
    @if (dataSourceNotFound) {
      <div class="text-center">
        <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
      </div>
    }
    @if (actionsDisabled()) {
      <div class="text-center">
        <h1>{{ t('widgets.not-supported-5-point-dashboard') }}</h1>
      </div>
    }
    @if (hasInvalidComparison) {
      <div class="text-center">
        <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
      </div>
    }
    @if (!dataSourceNotFound && sentimentScale === 3 && !hasInvalidComparison) {
      @if (!isLoading) {
        <div #tableWrapper class="sentiment_accuracy__table-wrapper">
          @if (noDocuments || noData) {
            <div class="text-center">
              <h1>
                @if (noDocuments) {
                  {{ t('widgets.no-documents-found') }}
                }
                @if (noData) {
                  {{ t('widgets.no-data-found') }}
                }
              </h1>
            </div>
          }
          @if (!noData) {
            @if (!widget.payload.showPhrasesFor) {
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                [matSortActive]="sort.active"
                [matSortDirection]="sort.direction"
                (matSortChange)="sort = $event"
              >
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                <ng-container matColumnDef="sentiment">
                  <th mat-header-cell *matHeaderCellDef disabled>
                    {{ t('widgets.datatable.sentiment') }}
                  </th>
                  <td mat-cell *matCellDef="let item">
                    {{ item.sentiment }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="accuracy">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ t('widgets.datatable.accuracy') }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let item"
                    (click)="openCellMenu($event, item, 'accuracy')"
                  >
                    {{ item.accuracy * 100 | number: '1.0-0' }}%
                  </td>
                </ng-container>
                <ng-container matColumnDef="documentCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ t('widgets.datatable.document-count') }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let item"
                    (click)="openCellMenu($event, item, 'documentCount')"
                  >
                    {{ formatCellNumber(item.total) }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="incorrectCount">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ t('widgets.datatable.incorrect-count') }}
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let item"
                    (click)="openCellMenu($event, item, 'incorrectCount')"
                  >
                    {{ formatCellNumber(item.total - item.correct) }}
                  </td>
                </ng-container>
              </table>
            }
            @if (widget.payload.showPhrasesFor) {
              <app-widget-chart
                #phrasesChart
                [dashboard]="dashboard"
                [widget]="widget"
                [showGoBackButton]="true"
                (needRedraw)="redrawWidget($event)"
                (loadingStarted)="loadingStarted.emit($event)"
                (loadingFinished)="loadingFinished.emit($event)"
                (goBackClicked)="goBack()"
              ></app-widget-chart>
            }
          }
          <div
            [matMenuTriggerFor]="widgetContextMenuTrigger"
            #menuTriggerElement="matMenuTrigger"
            class="context-menu-trigger"
          ></div>
        </div>
      }
    }
  </div>

  <mat-menu #widgetContextMenuTrigger="matMenu" class="menu-with-xi-icons">
    <ng-template matMenuContent let-row="row" let-column="column" let-count="count">
      <div mat-menu-item disabled>
        @switch (column) {
          @case ('accuracy') {
            {{ t('widgets.datatable.accuracy') }}
          }
          @case ('documentCount') {
            {{ t('widgets.datatable.document-count') }}
          }
          @case ('incorrectCount') {
            {{ t('widgets.datatable.incorrect-count') }}
          }
        }
      </div>

      <button mat-menu-item [disabled]="count === 0" (click)="showDocuments(row, column)">
        <xi-icon [color]="count === 0 ? 'disabled' : 'orca'" icon="preview"></xi-icon>
        <div>{{ t('widgets.show-documents') }}</div>
      </button>

      @if (isSmartSummaryEnabled && !isReadOnly) {
        <div [matTooltip]="interactiveSmartSummaryMenu.tooltip">
          <button
            mat-menu-item
            (click)="openSmartSummary()"
            [disabled]="!interactiveSmartSummaryMenu.enabled"
          >
            <xi-icon
              [color]="!interactiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
              icon="lightbulb"
            ></xi-icon>
            <div>{{ interactiveSmartSummaryMenu.label }}</div>
          </button>
        </div>
      }
      @if (isSmartSummaryEnabled && !isReadOnly && pointSummaries?.length > 0) {
        <div [matTooltip]="removeInteractiveSmartSummaryMenu.tooltip">
          <button
            mat-menu-item
            (click)="removeSmartSummary()"
            [disabled]="!removeInteractiveSmartSummaryMenu.enabled"
          >
            <xi-icon
              [color]="!removeInteractiveSmartSummaryMenu.enabled ? 'disabled' : 'orca'"
              icon="indeterminate"
            ></xi-icon>
            <div>{{ removeInteractiveSmartSummaryMenu.label }}</div>
          </button>
        </div>
      }
      @if (isSmartSummaryEnabled && !isReadOnly) {
        <div [matTooltip]="downloadSmartSummaryRequestToolTip">
          <button
            mat-menu-item
            (click)="downloadSmartSummarySpotERequest()"
            [disabled]="downloadingSpoteRequest || !canCreateSmartSummary"
          >
            <xi-icon
              [color]="downloadingSpoteRequest || !canCreateSmartSummary ? 'disabled' : 'orca'"
              icon="download"
            ></xi-icon>
            <div>{{ t('widgets.smart-summary.download-smart-summary-spote-request') }}</div>
          </button>
        </div>
      }

      <button mat-menu-item [disabled]="count === 0" (click)="showPhrases(row, column)">
        <xi-icon [color]="count === 0 ? 'disabled' : 'orca'" icon="visibility"></xi-icon>
        <div>{{ t('widgets.show-phrases-for-item') }}</div>
      </button>
    </ng-template>
  </mat-menu>

  @if (showDocumentViewModal) {
    <app-lex-xi-modal
      [isVisible]="showDocumentViewModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onDocumentViewModalClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showDocumentViewModal) {
          <app-document-view-dialog
            [options]="documentViewModalOptions"
            (modalClosed)="onDocumentViewModalClosed($event)"
          ></app-document-view-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showSmartSummaryModal) {
    <app-lex-xi-modal
      [isVisible]="showSmartSummaryModal"
      [canBackdropClose]="false"
      maxWidth="80vw"
      (close)="onSmartSummaryClosed($event)"
    >
      <ng-template appXIModalContent>
        @if (showSmartSummaryModal) {
          <app-interactive-smart-summary
            [options]="interactiveSmartSummaryOptions"
            (modalClosed)="onSmartSummaryClosed($event)"
            (addComment)="onAddSmartSummaryComment($event)"
            (addNotes)="onAddSmartSummaryNotes($event)"
          ></app-interactive-smart-summary>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
</ng-container>
